import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  logisticsSafety,
  manufacturingSteel,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: 'Smart Logistics Center (Trung tâm Logistics thông minh) đóng vai trò quan trọng trong quản lý logistics và chuỗi cung ứng hiện đại. Tốc độ, độ chính xác và hiệu quả là những yếu tố cốt lõi của mọi hoạt động logistics, và việc tối ưu hóa các yếu tố này là một trong những nhiệm vụ quan trọng quyết định sự thành công và năng lực cạnh tranh của doanh nghiệp.',
  keywords:
    'Trung tâm logistics quy mô lớn, logistics quy mô lớn, smart logistics, quản lý kho hàng, smart inventory, quản lý kho thông minh, trung tam logistics quy mo lon, logistics quy mo lon, smart logistics, quan ly kho hang, smart inventory, quan ly kho thong minh.',
  ogSite: 'Smart Logistics Center ứng dụng công nghệ UWB',
  title: 'Smart Logistics Center ứng dụng công nghệ UWB',
  ogUrl: 'https://orbro.io/vi/blog/uwbLogistics',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AKsag4PMiWc5DIFUhcXlBfDRp2o8d3EJ_Z4ffawsJSoDWT70JslXvsXOw5KgNd3q5wgkx3TUzMx42JtuNcCYfLVsl4W8GEIevw-Q84jKo4Nm-Bu0CdH4qgYaA6OwgyC4paHI32-VbALd50n6lLWH0CNWUBFGOgkoXzFpchLLz2INpLMFbzPNsPlnWPK1V9vPzvJlVDr6GdB4SKKQM0XHaIbQFHd9xwu4quaqFpAPoJ6HMEZb_-PMBnKc0D5CSBQ0cBlJqHFHacrj-TPxhfLG1QeDfnIkE25ooGaiwz76DMvLqIqnCBcYPYsStKF8weqz_g5Sh3LyHpvveZL2GPOiRD0SvaNatRUPDeyK5_11bB9t42SpjZZuEYUHIb-ivBBOXxdCGJt4MDAl3pcM65PWS1DDBqUcncZ1uHo8_1b5wHawqsOZ6F6H5hFzzLKZHEnfibNYE0UgKoBvRHlCqz5y6SPTqcRTsaUzu0aj7LRETSi4adhGjvfgOQ0mILavMKp9ei41wAcC7zWl67f5uYGBTU9z-Sq8C0ncIG_tUmKIf3-bXeS0dBjJyYZQCPSytqKSFAPWzcxUHqp7GKdX6cFyMRkop-S-SzwB0spx8E_3wdecdTkX3H6TX_uSGKaFOmSZbMrm6YZaEJFUrDH7Zl6RAx-sIJoDA1qoEx4ULktfnVpEt-DaFyVJDuiY-qC54aoH8YJ-FHWixIFG6BpVGCp6pME79yITG3fDMVFfRfSnz32WTrpb_8htFe2iu3M4d8NRRm48c5ovfiTkWMRNLFRdSkRPDZ0qGVEs6FSU-UrGu95_QwTHwqWWceSPTdxRiPAMtR2x1zyg7au0pLgIDeVoChJuZ9nE6t6659ZBQsZnWHA_DOSrdWzMPvdrr7qTj5_byxnTgW0vC8flxGkf0I8g8DR3cWtJ7tWVMQpUwTh5dOl_7fQ62ZRN9fgnXvx-GKnP1ZkEz3Vzuz4Z4PPVAmS7gOHS8L-PMTJ9WF7-mwLVknLpgxrlSGhYuW4ognx12nU0yiuSDxPKLq-jS5DFHHeIN6O4SQtVgRnga99vTOi9QmhV_pWMXbuvhzEhbGMgxkHTLZV_iwH0PTl6MWgJAG2HOaUSAT9uZ71Kvv6RWyt_VLkET4AuJ480_wC7DHvDneJqb7pgtUZpbVa_aYXNB5AouMSyFVoHrsGRLZTJ1vhiKdQgfy5exsXJY2e6qCVrSpsVYQufijgQ3dc4PjAGJ8IY8krq2igby7D2AGnRDmJO6q7zwf7hNktGXBM4jR6YcUh1GbRmzm4Ios1p7z3EaKsY59m7zLrNjbZHA6o2Dcgf2cxFNBfwMiShDmtQSMQZHzFEY4x6PCByTF_Pb0tKe1Pu5iuiUm-HYkboa8BEWXYjFVvEc05axWugdX6zrW4ijr0xd_xMSZRCmZ0lXPBOekY03zX5ajinw6TRDfQo3l5HqEmCXgAZKlWZAgfBp67huSzzosSWfm2dY9b4bTGfgrfKZTeu9IJx8El-7m7PcTU4Bv-g584Bp0wcyv2tjG2aDCIz1BgGuXW7oNyImmGFxwWArxN0_Xk=w2000-h1946',
  ogType: 'website',
  date: '2023-09-05',
  tag1: '#Trungtamlogisticsquymolon',
  tag2: '#Logisticsquymolon',
  tag3: '#Smartlogistics',
  tag4: '#Quanlykhohang',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Smart Logistics Center (Trung tâm Logistics thông minh) đóng vai trò quan trọng trong quản lý logistics và chuỗi cung ứng hiện đại. Tốc độ, độ chính xác và hiệu quả là những yếu tố cốt lõi của mọi hoạt động logistics, và việc tối ưu hóa các yếu tố này là một trong những nhiệm vụ quan trọng quyết định sự thành công và năng lực cạnh tranh của doanh nghiệp. Công nghệ UWB (Ultra-Wideband) đang nổi lên như một giải pháp hiện đại cho những thách thức này. Trong bài viết này, chúng ta sẽ xem xét cách thức và lợi ích của việc sử dụng công nghệ UWB để xây dựng Smart Logistics Center.',
      dot: '',
    },
    {
      head: 'Công nghệ UWB là gì?',
      subHead: '',
      desc: 'Công nghệ UWB là công nghệ hỗ trợ truyền thông không dây bằng cách sử dụng băng thông rất rộng. Băng thông rộng này rất hữu ích cho việc truyền dữ liệu nhanh chóng và theo dõi vị trí chính xác. Công nghệ UWB được biết đến là công nghệ theo dõi vị trí có độ chính xác cao, có thể theo dõi vị trí của vật thể chính xác đến từng milimet, và đặc điểm này mở rộng vô hạn khả năng ứng dụng tại các trung tâm logistics.\n\n Dưới đây, chúng ta hãy cùng tìm hiểu xem Smart Logistics Center mang lại những lợi ích gì.',
      dot: '',
    },
    {
      head: '\n Lợi ích của Smart Logistics Center ứng dụng công nghệ UWB',
      subHead: 'Theo dõi vị trí chính xác',
      desc: 'Sử dụng công nghệ UWB, có thể theo dõi vị trí chính xác của mọi vật thể trong trung tâm logistics theo thời gian thực. Nhờ đó, có thể nâng cao độ chính xác và hiệu quả của việc quản lý hàng tồn kho, di chuyển hàng hóa và quy trình làm việc.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hỗ trợ tự động hóa và robot hóa',
      desc: 'Tại Smart Logistics Center, cần vận hành hiệu quả các robot và thiết bị tự động hóa. Công nghệ UWB cho phép giao tiếp thời gian thực với robot và thiết bị tự động, qua đó tăng cường tự động hóa quy trình làm việc.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường an ninh và an toàn',
      desc: 'Sử dụng UWB, có thể giám sát mọi hoạt động bên trong trung tâm logistics và ứng dụng vào giám sát an ninh. Nó có thể được tích hợp vào nhiều hệ thống an ninh và an toàn khác nhau như theo dõi di chuyển hàng hóa, kiểm soát ra vào, phát hiện hỏa hoạn, v.v.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích dữ liệu thời gian thực',
      desc: 'Công nghệ UWB có thể thu thập và phân tích dữ liệu thời gian thực, do đó cho phép đưa ra quyết định theo thời gian thực đối với các hoạt động logistics. Nhờ đó, có thể tối ưu hóa quy trình logistics.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hiệu quả năng lượng',
      desc: 'Công nghệ UWB xác định chính xác vị trí của vật thể, do đó có thể giảm thiểu tiêu thụ năng lượng. Có thể xây dựng một trung tâm logistics sử dụng tài nguyên hiệu quả hơn và thân thiện hơn với môi trường.',
      dot: '',
    },
    {
      head: 'Các trường hợp ứng dụng công nghệ UWB tại Trung tâm Logistics',
      subHead: 'Quản lý hàng tồn kho',
      desc: 'Theo dõi chính xác hàng tồn kho trong trung tâm logistics để ngăn ngừa lỗi tồn kho và giảm chi phí tồn kho.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý thiết bị nặng',
      desc: 'Theo dõi các thiết bị nặng được sử dụng tại hiện trường logistics để quản lý dễ dàng. Đồng thời cũng có thể phòng ngừa tai nạn va chạm.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý người lao động',
      desc: 'Xác định vị trí của người lao động theo thời gian thực để bố trí nhân lực hiệu quả hơn, hoặc phát hiện tai nạn an toàn theo thời gian thực để ứng phó nhanh chóng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Xuất/nhập tự động',
      desc: 'Tự động ghi lại thời gian một tài sản cụ thể đi qua một khu vực nhất định, giúp cắt giảm nhân lực không cần thiết.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Dây chuyền lắp ráp ô tô',
      desc: 'Tại nhà máy sản xuất ô tô, có thể sử dụng UWB để theo dõi vị trí chính xác của các bộ phận ô tô, qua đó nâng cao hiệu quả sản xuất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Drone không người lái',
      desc: 'Sử dụng drone không người lái bên trong trung tâm logistics để vận chuyển và giám sát sản phẩm một cách hiệu quả.',
      dot: '',
    },
    {
      head: 'Kết luận',
      subHead: '',
      desc: 'Công nghệ UWB đang dẫn đầu sự đổi mới của Smart Logistics Center và mang lại những thay đổi lớn trong lĩnh vực logistics và quản lý chuỗi cung ứng. Thông qua các lợi ích như theo dõi vị trí chính xác, hỗ trợ tự động hóa, tăng cường bảo mật, hiệu quả năng lượng và phân tích dữ liệu thời gian thực, doanh nghiệp có thể củng cố năng lực cạnh tranh và thực hiện các hoạt động logistics hiệu quả hơn. Các doanh nghiệp tích cực áp dụng công nghệ UWB để xây dựng Smart Logistics Center sẽ đạt được thành công lớn hơn trong tương lai.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/vi/enterprise/manufacturing/steel',
      },
    ],
  },
};
